import { render, staticRenderFns } from "./NovelTemplate.vue?vue&type=template&id=045426c2&scoped=true"
var script = {}
import style0 from "./NovelTemplate.vue?vue&type=style&index=0&id=045426c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045426c2",
  null
  
)

export default component.exports